import React, { useEffect } from 'react';
import Diagnose from '~/presentation/pages/Diagnose';
import { makeReduxListDiagnosisReport } from '../../usecases/diagnosisReport/ListDiagnosisReportFactory';

const MakeDiagnoseFactory: React.FC = () => {
  return <Diagnose />;
};

export default MakeDiagnoseFactory;
